import { ArrowUpRight, Instagram, Phone } from "lucide-react";
import ornament from "@/assets/ornament.png";

const MENUS = [
  {
    name: "Cafe food",
    href: "https://deliveroo.co.uk/menu/London/north-harrow/the-moon-cafe-headstone-gardens?day=today&geohash=gcpv2qf0vtdx&time=ASAP",
    testid: "footer-cafe-link",
  },
  {
    name: "Sweet delights",
    href: "https://deliveroo.co.uk/menu/London/north-harrow/the-moon-sweet-delights?day=today&geohash=gcpv2qf0vtdx&time=ASAP",
    testid: "footer-sweet-link",
  },
  {
    name: "Burgers",
    href: "https://deliveroo.co.uk/menu/London/north-harrow/the-moon-burgers?day=today&geohash=gcpv2qf0vtdx&time=ASAP",
    testid: "footer-burgers-link",
  },
];

const INSTAGRAM_URL = "https://www.instagram.com/stories/themooncafeuk/";

export default function Footer() {
  return (
    <footer className="border-t border-line/60 bg-ink2/40">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-9 px-6 py-16 text-center md:px-12">
        <img src={ornament} alt="" className="h-12 w-12 object-contain opacity-90" />
        <div>
          <p className="font-wordmark text-base tracking-[0.35em] text-cream">THE MOON</p>
          <p className="mt-2 font-sans text-[10px] uppercase tracking-[0.55em] text-sage-dim">
            Harrow
          </p>
        </div>
        <nav
          className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3"
          data-testid="footer-nav"
        >
          {MENUS.map((m) => (
            <a
              key={m.name}
              href={m.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={m.testid}
              className="group inline-flex items-center gap-1.5 font-sans text-xs uppercase tracking-[0.2em] text-sage transition-colors duration-300 hover:text-cream"
            >
              {m.name}
              <ArrowUpRight className="h-3 w-3 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </a>
          ))}
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="inline-flex items-center gap-2 font-sans text-xs uppercase tracking-[0.2em] text-sage transition-colors duration-300 hover:text-cream"
          >
            <Instagram className="h-3.5 w-3.5" />
            Instagram
          </a>
          <a
            href="tel:+442084275073"
            data-testid="footer-phone-link"
            className="inline-flex items-center gap-2 font-sans text-xs uppercase tracking-[0.2em] text-sage transition-colors duration-300 hover:text-cream"
          >
            <Phone className="h-3.5 w-3.5" />
            020 8427 5073
          </a>
        </nav>
        <p className="font-sans text-xs font-light text-sage-dim">
          © {new Date().getFullYear()} The Moon Cafe, Headstone Gardens, Harrow HA2 6PN — new
          website coming soon.
        </p>
      </div>
    </footer>
  );
}
